import ChannelEditCoverPage from '../ChannelEdit/ChannelEditCoverPage'

export default ChannelEditCoverPage


// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditCoverPage.js